const AdminGridStyle = {
    paper: {
        width: '100%',
        borderRadius: 0,
        boxShadow: 'none',
        background: "inherit",
        borderTop: "1px solid #c5c5c5",
        ".MuiTableContainer-root": { background: "#FDFCFC", borderBottom: 0, borderColor: "#ededed", boxSizing: "border-box" }
    },
    tableHeadRow: {
        borderBottom: 0,
        ".MuiTableCell-paddingCheckbox": { borderBottom: 0 }
    },
    tableHeadCell: {
        padding: 0,
        fontSize: 15,
        color: "#34495e",
        fontVariant: "tabular-nums",
        fontFamily: "Pretendard-Medium",
        letterSpacing: -1,
        boxSizing: "border-box",
        "&": {border: "none"},
        borderColor: "#C5C5C5",
        background: "#f0f8ff",
        overflow: "revert",
        ".MuiButtonBase-root.Mui-active .MuiSvgIcon-root": { display: "inline-block" },
        ".MuiButtonBase-root:hover .MuiSvgIcon-root": { display: "inline-block" },
        ".MuiButtonBase-root .MuiSvgIcon-root": { display: "none", position: "absolute", right: "-20px" }
    },
    tableHeadChkBoxCell: {
        padding: "0px !important",
        width: "30px",
        background: "#f0f8ff",
        ".MuiButtonBase-root .MuiSvgIcon-root": { width: "20px", color: "#333333" },
        ".css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root": { padding: "0 5px" },
        ".MuiCheckbox-root": { padding: "0 7px" }
    },
    tableBody: {
        ".MuiTableCell-body": { padding: 0 }
    },
    tableBodyRowHover: {
        "&:hover": {
            backgroundColor: "#f3f9ff",
            cursor: "pointer"
        },
    },
    tableBodyCell: {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        fontVariant: "tabular-nums",
        fontFamily: "Pretendard-Regular",
        fontSize: 14,
        color: "#666666",
        letterSpacing: "-0.75px",
        boxSizing: "border-box",
        borderTop: "1px solid #DDDDDD",
        borderBottom: "none",
        background: "transparent",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"

    },
};
export default AdminGridStyle;